import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { AppsState } from './state';

const defaultState: AppsState = {
  apps: [],
};

export const appsModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
